<div class="invoice-container">
  <div class="header">
    <h2 style="font-family: 'Lato', sans-serif; font-weight: 900">Nouvelle facture</h2>
    <div class="button-container">
      <div class="view-list-container">
        <mat-icon (click)="close.emit()">view_list</mat-icon>
      </div>
      <button mat-raised-button (click)="generateInvoice()" style="color: #16191e">Générer</button>
    </div>

  </div>

  <div class="client-container">
    <div class="subtitle">Nom client</div>
    <input
      type="text"
      class="input-client"
      [(ngModel)]="clientName"
    />
  </div>

  <section class="section">
    <div class="header-section">
      <div class="subtitle">Produits</div>
      <div class="add-button-container" (click)="addProduct()">
        <mat-icon>add</mat-icon>
        Ajouter
      </div>

    </div>

    <table>
      <colgroup>
        <col class="col-produit"/>
        <col class="col-type-prix"/>
        <col class="col-quantite"/>
        <col class="col-prix"/>
        <col class="col-total"/>
        <col class="col-action"/>
      </colgroup>
      <thead>
      <tr>
        <th>Produit</th>
        <th>Type de prix</th>
        <th>Quantité</th>
        <th>Prix unitaire</th>
        <th>Total</th>
        <th></th> <!-- pour le bouton supprimer -->
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let product of products; index as product_index">
        <td style="padding: 0">
          <div class="dropdown">
            <input
              type="text"
              class="input-name"
              [(ngModel)]="product.description"
              (input)="filterItems(product.description)"
              (focus)="openDropdown(product_index)"
              (blur)="hideDropdown(product_index)"
            />
            <ul *ngIf="filteredItems.length > 0 && product.showDropDown" class="dropdown-list">
              <li *ngFor="let item of filteredItems" (click)="selectItem(item, product_index)">
                {{ item.name }}
              </li>
            </ul>
          </div>
        </td>

        <td>
          <select
            class="input-name"
            [(ngModel)]="product.priceType"
            (change)="changePriceType(product_index, product.priceType || 'sales_price')">
            <option value="sales_price">Prix carton</option>
            <option value="pack_price">Prix paquet</option>
            <option value="piece_price">Prix piece</option>
          </select>
        </td>

        <td>
          <input
            type="number"
            class="input-name"
            min="1"
            [(ngModel)]="product.quantity"
          />
        </td>

        <td>
          <input
            type="number"
            class="input-name"
            min="0"
            [(ngModel)]="product.price"
          />
        </td>

        <td>{{ format_price(product.quantity * product.price) }}</td>

        <td>
          <mat-icon (click)="removeProduct(product.uuid)" style="color: brown">delete</mat-icon>
        </td>
      </tr>
      </tbody>
    </table>

  </section>

  <section class="summary">
    <div class="subtitle">
      <label>Total:</label>
      <strong>{{ format_price(total) }}</strong>
    </div>
  </section>
</div>

